import React, { FC, useState } from 'react';
import { Study } from '../../api/studykit';
import { useNavigate } from 'react-router-dom';
import { FabButton, Menu, MenuItem, Typography } from '@dls/react-core';
import { ButtonProps } from '@material-ui/core';
import { Icon } from '@dls/react-icon';
import { RoutePaths } from '../../routes/main-routes';
import { RemoveStudyDialog } from '../dialogs/remove-study-dialog';
import { useAuthorization } from '../../context/authorization';

interface MenuItemProps {
  study: Study;
}

export const StudyMenu: FC<MenuItemProps> = ({ study }) => {
  const navigate = useNavigate();
  const [studyDeleteDialogOpen, setStudyDeleteDialogOpen] = useState(false);
  const { hasPermissionsForStudy } = useAuthorization();

  const editAction = {
    label: 'View study',
    handleAction: () => navigate(`/${RoutePaths.Studies}/${study.id}/edit`),
    disabled: !hasPermissionsForStudy(study.id, ['Study.Read']),
  };

  const deleteStudyAction = {
    label: 'Delete study',
    handleAction: () => setStudyDeleteDialogOpen(true),
    disabled: !hasPermissionsForStudy(study.id, ['Study.Delete']),
  };

  const actions = [editAction, deleteStudyAction];
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement>();
  const handleClick: ButtonProps['onClick'] = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e: MouseEvent) => {
    e.stopPropagation();
    setAnchorEl(undefined);
  };
  return (
    <>
      <FabButton size="small" variant="extended" dls_variant="quietEmphasis" onClick={handleClick}>
        <Icon name={'ThreeDotsVertical'} size={'m'} />
      </FabButton>
      <Menu
        getContentAnchorEl={null}
        PaperProps={{
          className: 'DLSMenuList',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {actions.map((a) => (
          <MenuItem
            key={a.label}
            onClick={(e: MouseEvent) => {
              a.handleAction();
              handleClose(e);
            }}
            disabled={a.disabled}
          >
            <Typography>{a.label}</Typography>
          </MenuItem>
        ))}
      </Menu>

      {!deleteStudyAction.disabled && (
        <RemoveStudyDialog
          study={study}
          open={studyDeleteDialogOpen}
          onClose={() => setStudyDeleteDialogOpen(false)}
        />
      )}
    </>
  );
};
